export class ApiError extends Error {
    public readonly code: string;
    public readonly severity: string;
    public readonly reason: string;
    public readonly isBusinessError: boolean;

    constructor(reason: string, code: string, severity: string, name: string, isBusinessError = true) {
        super(reason);

        Object.setPrototypeOf(this, ApiError.prototype);

        this.code = code;
        this.severity = severity;
        this.reason = reason;
        this.name = name || 'ApiError';
        this.isBusinessError = isBusinessError;
    }

    public static fromAxiosResponse(error: any): ApiError {
        const { name, code, severity, reason } = error?.response?.data?.errors[0] || {};
        return new ApiError(reason, code, severity, name);
    }

    public static fromError(error: Error): ApiError {
        const { name, message } = error || {};
        return new ApiError(message, 'unknown', 'error', name, false);
    }
}
